import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'

export const useItemsStore = defineStore('useItemsStore', {
  id: 'useItemsStore',
  state: () => ({
    items: [],
    api: '/api/v1/items'
  }),
  getters: {
    ...getters,
  },
  actions: {
    ...actions,
  }
})
